import classNames from 'classnames'
import { type PropsWithChildren } from 'react'

type PropTypes = {
  className?: string,
} & PropsWithChildren

const BrandBackground = ({ children, className }: PropTypes) => {
  return (
    <div
      className={classNames(
        'bg-primary-500 rounded-[10px] flex items-center justify-center shadow-[0_1.6px_2.5px_0px_rgba(0,0,0,0.18)]',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default BrandBackground
